import { Base } from '@models/base.model';
import { PageObject } from '@models/page-object.model';
import { deserialize, serializable } from 'serializr';

export class TestCaseType extends Base implements PageObject {
  @serializable
  public displayName: string;
  @serializable
  public name: string;
  @serializable
  public projectId: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TestCaseType, input));
  }
}
